
import { lazy, Suspense } from 'react';

// Lazy load the TawkToWidget component
const TawkToWidget = lazy(() => import('./TawkToWidget'));

const LazyTawkToWidget = () => {
  return (
    <Suspense fallback={null}>
      <TawkToWidget />
    </Suspense>
  );
};

export default LazyTawkToWidget;
